export default __webpack_public_path__ + "static/media/email.27317ed3.csv";